// Return existing element(s)
function getElement(id) {
    return document.getElementById(id);
}

function getSelector(selector) {
    return document.querySelector(selector);
}

function getAllElements(selector) {
    return document.querySelectorAll(selector);
}

// Sets element attribute
function setElementAttribute(id, attribute, value) {
    const element = getElement(id);
    if (element) {
        element[attribute] = value;
    }
}

function setAttrByArray(element, attrArray) {
    for (let { attr, value } of attrArray) {
        element.setAttribute(attr, value);
    }
}

// Show/hide spinner to give container time to load
function toggleSpinnerAndContainer(spinnerId, containerId, delay) {
    const spinner = document.getElementById(spinnerId);
    const container = document.getElementById(containerId);

    if ( spinner ) {
        spinner.classList.add('visible-container');
        spinner.style.display = 'block';
    }

    if ( spinner && container ) {
        setTimeout(() => {
            spinner.classList.remove('visible-container');
            spinner.style.display = 'none';
            container.classList.add('visible-container');
            container.classList.remove('hidden-container');
        }, delay);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    function scrollToElementWithOffset(elementId, offset) {
        const element = document.getElementById(elementId);
        if (element) {
            const scrollAnchor = document.createElement('a');
            scrollAnchor.classList.add('scroll-anchor');
            scrollAnchor.style.top = `-${offset}px`;
            scrollAnchor.style.visibility = 'hidden';

            element.parentNode.insertBefore(scrollAnchor, element);
            scrollAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setTimeout(() => scrollAnchor.remove(), 1000);
        }
    }

    function handleLinkClick(event) {
        const targetId = event.currentTarget.getAttribute('href').split('#')[1].split('?')[0];
        if (document.getElementById(targetId)) {
            event.preventDefault();
            scrollToElementWithOffset(targetId, 107);
        }
    }

    // Add event listeners to all anchor links
    const anchorLinks = document.querySelectorAll('a[href*="#"]');
    anchorLinks.forEach(link => {
        link.addEventListener('click', handleLinkClick);
    });

    // Check if there's an anchor in the URL on page load and splits off parameters
    const url = new URL(window.location.href);
    const hash = url.hash.split('?')[0];
    const anchorFromURL = hash.substring(1);
    if (anchorFromURL) {
        setTimeout(() => scrollToElementWithOffset(anchorFromURL, 107), 100);
    }
});


const closeModalButton = document.getElementById('closeModal');
const exitNotificationCollapse = document.getElementById('exitNotification');

if (closeModalButton && exitNotificationCollapse) {
    closeModalButton.addEventListener('click', function() {
        const bsCollapse = new bootstrap.Collapse(exitNotificationCollapse, {
            toggle: false
        });
        bsCollapse.hide();
    });
}

export { 
    getElement,
    getSelector,
    getAllElements,
    setElementAttribute, 
    setAttrByArray,
    toggleSpinnerAndContainer,
};